import { Component, inject } from '@angular/core';

import { SnackbarService } from '../../services/snackbar.service';
import { SnackbarComponent } from './snackbar.component';

@Component({
  selector: 'app-snackbar-stack',
  templateUrl: './snackbar-stack.component.html',
  styleUrls: ['./snackbar-stack.component.scss'],
  imports: [SnackbarComponent],
})
export class SnackbarStackComponent {
  private readonly snackbarService = inject(SnackbarService);

  readonly stack = this.snackbarService.stack;

  onDismiss(id: string): void {
    this.snackbarService.dismiss(id);
  }
}
